import SimpleUri from '@ms/odsp-utilities/lib/uri/SimpleUri';

/**
 * @internal
 */
export function getLeafFolderIndex(folderPath: string, listFullUrl: string): number {
  let index = -1;
  if (folderPath) {
    let listUrl = listFullUrl;
    listUrl = new SimpleUri(listUrl).path; // get server relative url.

    if (folderPath.lastIndexOf(listUrl, 0) > -1 && folderPath.length > listUrl.length) {
      index = folderPath.lastIndexOf('/');
    }
  }
  return index;
}
